// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230438/js/" + chunkId + "." + {"44":"d64418d3","225":"28512e1a","481":"7609f84e","486":"00565dfd","770":"da6077c2"}[chunkId] + ".0.40448640877410236.chunk.js";
};